import { Card, Col, Container, Image, Row, Button, Form, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import default_profile_image from '../../content-panes/admin-candidate/candiate-info-nav/img/avatar.png';
import profilebackButtonIcon from '../../../assets/images/Ic_back.png';
import './candidateDetail.css';
import {
    faPen,
    faCircleCheck,
} from '@fortawesome/free-solid-svg-icons';
import { useEffect, useState, useRef } from 'react';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import { useCandidateUser } from '../candidateUserContext/candidateUserContext';
import { CandidatePostLoginService } from '../../../services/candidatePostLoginService';

export const CandidateDetails = () => {
    // const [user, setUser] = useState({});
    const [editState, setEditState] = useState({ emailId: false, phoneNumber: false });
    const [emailId, setEmailId] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const fileInputRef = useRef(null);
    const { candidate, setCandidate, loading } = useCandidateUser();


    const [showHibernateModal, setShowHibernateModal] = useState(false);
    const [isHibernate, setIsHibernate] = useState(false);
    const [showCloseModal, setShowCloseModal] = useState(false);
    const [isAccountClosed, setIsAccountClosed] = useState(false);

    const handleEditClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleFileChange = async (event) => {
        const file = event.target.files?.[0];
        if (!file) return;

        const tempUrl = URL.createObjectURL(file);
        setCandidate((prev) => ({ ...prev, imageBlobUrl: tempUrl }));

        try {
            const response = CandidatePostLoginService.uploadCandidateFile(
                (() => {
                    const fd = new FormData();
                    fd.append("file", file);
                    return fd;
                })(),
                "CANDIDATE_DP"
            );

            if (response?.data?.filePath) {
                setCandidate((prev) => ({
                    ...prev,
                    dpPath: response.data.filePath,
                }));

                setTimeout(() => window.location.reload(), 500);
            }
        } catch (err) {
            console.error("Error uploading profile picture:", err);
        }
    };


    const handleHibernateClick = (e) => {
        e.preventDefault();
        setShowHibernateModal(true);
    };

    const handleConfirmHibernate = () => {
        setIsHibernate(true);
        setShowHibernateModal(false);
    };

    const handleCancelHibernate = () => {
        setShowHibernateModal(false);
    };

    const handleCloseAccountClick = (e) => {
        e.preventDefault();
        setShowCloseModal(true);
    };

    const handleConfirmClose = () => {
        setIsAccountClosed(true);
        setShowCloseModal(false);
    };

    const handleCancelClose = () => {
        setShowCloseModal(false);
    };

    // const handleOpenModal = () => setShowModal(true);
    // const handleCloseModal = () => setShowModal(false);

    return (
        <>
            <div className="fluid-container">
                {loading && (
                    <div className="mycandidates-loader-container">
                        <div className="mycandidates-loader"></div>
                    </div>
                )}
                {/* Breadcrumb */}
                <div className="profile-candidate-breadcrumb">
                    <div
                        className="breadcrumb-candidate"  >
                        <Link
                            to={-1}
                            style={{ color: '#99A4AF', textDecoration: 'none' }}
                            state={{ scrollPosition: sessionStorage.getItem("initialScrollPosition") }}
                        >
                            <img src={profilebackButtonIcon} alt="Back" className="profile-breadcrumb-back-icon" />{' '}
                            <span className="profile-breadcrumb-back-text">Back</span>
                        </Link>
                    </div>
                </div>

                <Container className="candidate-user-profile-container">
                    <Row className="candidate-profile-title-row">
                        <Col>
                            <h4 className="candidate-profile-heading">My Profile</h4>
                        </Col>
                    </Row>

                    <Row className="candidate-profile-container">
                        <Col md={3} className="candidate-profile-left">
                            <div
                                className="rounded-circle overflow-hidden position-relative candidate-profile-pic-container"
                                onClick={handleEditClick}
                                style={{ cursor: "pointer" }}
                            >
                                <Image
                                    src={candidate?.imageBlobUrl || default_profile_image}
                                    alt="Profile Image"
                                    onError={(e) => (e.target.src = default_profile_image)}
                                />
                                <input
                                    type="file"
                                    ref={fileInputRef}
                                    style={{ display: "none" }}
                                    accept="image/*"
                                    onChange={handleFileChange}
                                />
                                <div
                                    className="candidate-overlay d-flex align-items-center gap-2"
                                    role="button"
                                    tabIndex={0}
                                    onKeyDown={(e) => { if (e.key === "Enter") handleEditClick(); }}
                                >
                                    <FontAwesomeIcon icon={faPen} color="#F35824" />
                                    <span>Edit Image</span>
                                </div>
                            </div>

                            <div className="mt-3 candidate-profile-text">
                                <h5 className="candidate-profile-username">{candidate?.name}</h5>
                                <p className="candidate-profile-role">Candidate</p>
                                <p className="candidate-profile-userid">User ID: {candidate?.id}</p>
                            </div>
                        </Col>

                        <Col md={8} className="candidate-profile-right">
                            <Card className="candidate-personal-info-card mb-4">
                                <h5 className="candidate-personal-info-heading">Personal Info</h5>
                                <Row>
                                    <Col xs={12} md className="candidate-profile-info-section">
                                        <div className="candidate-profile-info-label-container">
                                            <p className="candidate-profile-info-label">
                                                Email ID <FontAwesomeIcon icon={faCircleCheck} className="candidate-profile-verified-icon" />
                                            </p>

                                        </div>
                                        {editState.emailId ? (
                                            <Form.Control className="candidate-profile-form-control" value={candidate?.email} onChange={(e) => setEmailId(e.target.value)} />
                                        ) : (
                                            <p className="candidate-profile-info-value">{candidate?.email}</p>
                                        )}
                                        <div className="candidate-profile-horizontal-divider d-md-none"></div>

                                    </Col>

                                    <Col xs="auto" className="d-none d-md-flex align-items-center">
                                        <div className="candidate-profile-vertical-divider"></div>
                                    </Col>

                                    <Col xs={12} md className="candidate-profile-info-section">
                                        <div className="candidate-profile-info-label-container">
                                            <p className="candidate-profile-info-label">
                                                Mobile Number <FontAwesomeIcon icon={faCircleCheck} className="candidate-profile-verified-icon" />
                                            </p>

                                        </div>
                                        {editState.phoneNumber ? (
                                            <Form.Control className="candidate-profile-form-control" value={candidate?.phone} onChange={(e) => setPhoneNumber(e.target.value)} />
                                        ) : (
                                            <p className="candidate-profile-info-value">{candidate?.phone}</p>
                                        )}
                                    </Col>
                                </Row>
                            </Card>
                            {/* <Card className="candidate-company-info-card mb-4">
                                <div className="d-flex justify-content-between align-items-center">
                                    <h5 className="candidate-company-info-heading">Manage Profile</h5>

                                </div>

                                <Row>
                                    <Col md={6}>
                                        <div className="candidate-profile-toggle-container">
                                            <span>Hibernate</span>
                                            <label className="switch" onClick={handleHibernateClick}>
                                                <input type="checkbox" checked={isHibernate} readOnly />
                                                <span className="slider round"></span>
                                            </label>
                                            {isHibernate && <span className="ms-2">Yes</span>}
                                        </div>

                                        <div className="candidate-profile-toggle-container">
                                            <span>Close Account</span>
                                            <label className="switch" onClick={handleCloseAccountClick}>
                                                <input type="checkbox" checked={isAccountClosed} readOnly />
                                                <span className="slider round"></span>
                                            </label>
                                            {isAccountClosed && <span className="ms-2">Yes</span>}
                                        </div>
                                    </Col>

                                </Row>

                                <Modal show={showHibernateModal} onHide={handleCancelHibernate} centered className="candidate-modal">
                                    <Modal.Header>
                                        <Modal.Title>Are you Sure you Want to put The Profile to Hibernate?</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        This will not show your profile to any new company. But, if you are already interacting with an existing company then you will remain visible.
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <button className="btn-cancel" onClick={handleCancelHibernate}>Cancel</button>
                                        <button className="btn-ok" onClick={handleConfirmHibernate}>Okay</button>
                                    </Modal.Footer>
                                </Modal>

                                <Modal show={showCloseModal} onHide={handleCancelClose} centered className="candidate-modal">
                                    <Modal.Header>
                                        <Modal.Title>Are you Sure you Want to Close your Account?</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        If you choose to close your account all your data will be erased and you will register again.
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <button className="btn-cancel" onClick={handleCancelClose}>Cancel</button>
                                        <button className="btn-ok" onClick={handleConfirmClose}>Okay</button>
                                    </Modal.Footer>
                                </Modal>

                            </Card> */}
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
};
